module.exports = __webpack_public_path__ + "img/54.7afe291b.png";